import { siteInfo } from '@/mocks/homepage';

export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full opacity-[0.06] pointer-events-none">
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full bg-primary-500 blur-[120px]"></div>
        <div className="absolute top-1/2 right-10 w-[400px] h-[400px] rounded-full bg-accent-500 blur-[100px]"></div>
        <div className="absolute -bottom-20 right-40 w-[300px] h-[300px] rounded-full bg-secondary-500 blur-[80px]"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-16">
          {/* Left Column - Text */}
          <div className="w-full md:w-1/2 flex flex-col items-start text-left">
            {/* Tag before H1 */}
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-5 whitespace-nowrap">
              追更漫画 · 实时连载
            </span>

            {/* H1 - only one per page */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-5">
              哔咔动漫 · 追更漫画连载实时更新
            </h1>

            {/* Slogan after H1 */}
            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              好看的漫画推荐与热门排行，追番不停
            </p>

            {/* Description paragraphs */}
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-lg">
              {siteInfo.description}
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center gap-6 md:gap-10 mb-8">
              {siteInfo.heroStats.map((stat, idx) => (
                <div key={idx} className="flex flex-col items-start">
                  <span className="text-2xl md:text-3xl font-heading text-foreground-900">
                    {stat.value}
                  </span>
                  <span className="text-xs text-foreground-500 mt-1">{stat.label}</span>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-base"></i>
                开始追更
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 border border-background-300 text-foreground-700 rounded-full font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line text-base"></i>
                查看热门排行
              </a>
            </div>
          </div>

          {/* Right Column - Main Visual */}
          <div className="hidden md:flex w-full md:w-1/2 justify-center items-center">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Colorful%20anime%20and%20manga%20collage%20style%20illustration%2C%20multiple%20popular%20characters%20in%20dynamic%20action%20poses%2C%20vibrant%20warm%20colors%20with%20orange%20red%20and%20gold%20tones%2C%20Japanese%20manga%20aesthetic%20with%20speed%20lines%20and%20action%20effects%2C%20energetic%20and%20exciting%20composition%2C%20clean%20background%20with%20subtle%20gradient&width=800&height=600&seq=hero-main&orientation=landscape"
                alt="哔咔动漫主视觉 - 热门漫画角色合集"
                className="w-full h-full object-cover"
              />
              {/* Overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}